import { z } from "zod"

/**
 * Trusted sources must be absolute HTTP(S) URLs without userinfo — the same
 * rule the backend enforces in `routes/trusted_sources.py`. Validating it here
 * keeps the submit button disabled instead of letting the request fail with a 400.
 */
const HTTP_PROTOCOL = /^https?$/

const hasNoUrlUserinfo = (value: string): boolean => {
  try {
    const parsed = new URL(value)
    return parsed.username === "" && parsed.password === ""
  } catch {
    return false
  }
}

export const createSourceFormSchema = (t: (key: string) => string) =>
  z.object({
    name: z
      .string()
      .min(1, t("sources.form.name_required"))
      .max(100, t("sources.form.name_max_length")),
    url: z
      .string()
      .min(1, t("sources.form.url_required"))
      .max(2000, t("sources.form.url_max_length"))
      .pipe(z.url({ error: t("sources.form.url_invalid"), protocol: HTTP_PROTOCOL }))
      .refine(hasNoUrlUserinfo, { error: t("sources.form.url_invalid") }),
  })

export type SourceFormData = {
  name: string
  url: string
}
